import {useTranslation} from 'react-i18next'

export const RootErrorFallback = () => {
  const {t} = useTranslation()

  return (
    <div
      style={{
        backgroundColor: '#01407F',
        color: '#FFFFFF',
        padding: '20px',
        textAlign: 'center',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <h1>{t('suite.HProduceSuite')}</h1>
      <p>{t('suite.rootErrorFallback.subtitle')}</p>
      <p>{t('suite.rootErrorFallback.description')}</p>
    </div>
  )
}
